<template>
  <div style="padding: 20px 20px">
    <section>
      <div class="title">用灵感点亮你的家居梦想</div>
      <div>
        <div class="desc">宜家俱乐部欢迎所有人，无论是热衷于改造家的家居达人，还是刚刚入门、需要帮助的新手。</div>
        <div class="desc">在宜家俱乐部，你就是灵感来源。</div>
        <div class="desc">我们通过了解你的喜好、创意和计划，为你呈现美妙的宜家体验，将你的家居梦想变为现实。</div>
        <div class="desc">加入宜家俱乐部，即可享受会员福利，更有不期而至的小惊喜等着你。</div>
      </div>
    </section>

    <section>
      <div class="title">会员专享福利</div>
      <div>
        <div class="desc">加入宜家俱乐部，你可以享受到一系列惊喜福利。</div>
      </div>
      <img class="full-width" src="@/assets/images/family-banner.jpg" />
      <img class="full-width" src="@/assets/images/family-introduction.jpg" />
    </section>
    <div @click="goToFamilyMiniprogram()" class="primary-button full-width">免费加入宜家俱乐部</div>
  </div>
</template>

<script>
const router = require("@/libs/router");

export default {
  data() {
    return {};
  },
  methods: {
    goToFamilyMiniprogram() {
      router.open('family_miniprogram');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  font-size: 14px;
}

section {
  margin-bottom: 30px;
}
.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 7px;
}
.desc {
  color: rgb(149, 149, 149);
  font-size: 12px;
}

img {
  margin: 15px 0px 20px 0px;
}

.primary-button {
  background-color: rgb(0, 124, 193);
}
</style>



// WEBPACK FOOTER //
// src/pages/app/IKEAFamily.vue